import React from 'react';

const SvgLocalisationContainer = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M15.79 10.004C18.652 9.898 21 12.08 21 14.792c0 2.676-2.678 5.492-4.696 7.076a.48.48 0 0 1-.66 0c-2.128-1.69-4.916-4.647-4.623-7.534.22-2.394 2.312-4.26 4.77-4.33zm.184 7.04c1.284 0 2.311-.985 2.311-2.182 0-1.233-1.027-2.218-2.311-2.218-1.247 0-2.275.985-2.275 2.218 0 1.197 1.027 2.183 2.275 2.183z"
      />
    </g>
  </svg>
);

export default SvgLocalisationContainer;
